// src/pages/LoginPage.js
import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Spin } from 'antd';
import { UserOutlined, LockOutlined, ShopOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext.js';

const { Title } = Typography;

const LoginPage = () => {
    const { login, isLoadingAuth } = useAuth();

    const [loginError, setLoginError] = useState(null);
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const onFinish = async (values) => {
        setLoginError(null);
        setIsLoggingIn(true);

        const result = await login(values);

        if (!result.success) {
            setLoginError(result.message || 'Login fallido. Verifique sus credenciales.');
        }
        // On success, App.js re-renders automatically because isAuthenticated changes.

        setIsLoggingIn(false);
    };

    const onFinishFailed = () => {
        setLoginError('Por favor complete todos los campos requeridos.');
    };

    if (isLoadingAuth) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Spin size="large" tip="Cargando..." />
            </div>
        );
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#f0f2f5',
        }}>
            <Card style={{ width: 400, textAlign: 'center', padding: '20px' }}>
                <Title level={2} style={{ marginBottom: 24 }}>HORIZONTE CASSA</Title>
                <Form
                    name="login"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                >
                    <Form.Item
                        label="Usuario"
                        name="username"
                        rules={[{ required: true, message: 'Por favor ingrese usuario' }]}
                    >
                        <Input prefix={<UserOutlined />} placeholder="Usuario" />
                    </Form.Item>

                    <Form.Item
                        label="Contraseña"
                        name="password"
                        rules={[{ required: true, message: 'Por favor ingrese contraseña' }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Contraseña" />
                    </Form.Item>

                    <Form.Item
                        label="Cliente / CUIT"
                        name="organizationIdentifier"
                        rules={[{ required: true, message: 'Por favor ingrese el identificador de su organización' }]}
                    >
                        <Input prefix={<ShopOutlined />} placeholder="Cliente o CUIT" />
                    </Form.Item>

                    {loginError && (
                        <Form.Item>
                            <Alert message={loginError} type="error" showIcon />
                        </Form.Item>
                    )}

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={isLoggingIn} block>
                            Ingresar
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default LoginPage;
